/*
 * Pagina prodotto senza taglia già scelta (snippets/gf-size-required.liquid).
 * Se il cliente prova ad aggiungere al carrello senza taglia: niente aggiunta, messaggio «Scegli la taglia»
 * e la prima taglia disponibile riceve il fuoco. Vale per il pulsante, per il tasto Invio (invio del modulo)
 * per il pulsante della barra fissa in basso e per la finestra dell'aggiunta rapida (stessa pagina prodotto).
 * Ascolto in fase di cattura sulla finestra: Horizon ascolta in cattura sul documento (on:submit, on:click),
 * quindi solo dalla finestra si arriva prima (come assets/gf-gift-composer.js).
 */

// la sezione della pagina prodotto, o la finestra dell'aggiunta rapida (fuori da ogni sezione, layout/theme.liquid)
const SCOPE = '.shopify-section, #quick-add-modal-content';

const missingSize = (scope) =>
  [...scope.querySelectorAll('[data-gf-size-required]')].find((fieldset) => !fieldset.querySelector('input:checked'));

function askForSize(event, fieldset) {
  event.preventDefault();
  event.stopImmediatePropagation();

  const msg = fieldset.parentElement?.querySelector('[data-gf-size-msg]');
  if (msg) {
    msg.hidden = false;
    // collegato al gruppo solo quando compare: prima sarebbe letto come descrizione a ogni ingresso
    fieldset.setAttribute('aria-describedby', msg.id);
    fieldset.setAttribute('aria-invalid', 'true');
    // testo riscritto: i lettori di schermo lo annunciano anche al secondo tentativo
    const text = (msg.dataset.text ||= msg.textContent);
    msg.setAttribute('role', 'alert');
    msg.textContent = '';
    setTimeout(() => (msg.textContent = text), 50);
  }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  fieldset.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
  const first = fieldset.querySelector('input:not([aria-disabled="true"])') || fieldset.querySelector('input');
  first?.focus({ preventScroll: true });
}

if (!window.gfSizeRequired) {
  window.gfSizeRequired = true;

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
      const section = form.closest(SCOPE);
      const fieldset = section && missingSize(section);
      if (fieldset) askForSize(event, fieldset);
    },
    true
  );

  window.addEventListener(
    'click',
    (event) => {
      // anche il clic sul pulsante principale: Horizon al clic fa partire l'animazione «aggiunto»
      const button =
        event.target instanceof Element &&
        event.target.closest('.sticky-add-to-cart__button, product-form-component [ref="addToCartButton"]');
      if (!button) return;
      const section = button.closest(SCOPE);
      const fieldset = section && missingSize(section);
      if (fieldset) askForSize(event, fieldset);
    },
    true
  );

  // scelta la taglia, il messaggio sparisce
  document.addEventListener('change', (event) => {
    const fieldset = event.target instanceof Element && event.target.closest('[data-gf-size-required]');
    const msg = fieldset?.parentElement?.querySelector('[data-gf-size-msg]');
    if (msg) msg.hidden = true;
    fieldset?.removeAttribute('aria-invalid');
  });
}
